<template>
  <section class="programs">
    <div class="max-w-6xl mx-auto px-4 py-12 text-white">
      <!-- Header -->
      <div class="text-center mb-12">
        <span class="bg-zinc-800 px-4 py-2 text-sm uppercase tracking-wider">Fitness Programs</span>
        <h2 class="text-4xl font-bold leading-tight italic mt-6">
          OUR ELITE PROGRAMS
        </h2>
      </div>

      <!-- Program Grid -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div
          v-for="program in programsData"
          :key="program.key"
          class="border border-[#FFE54F4D] p-8"
        >
          
          <div class="program-name">
            <h3 class="text-3xl font-bold italic mb-4">{{ program.name }}</h3>
          </div>
          
          <div class="program-desc">
            <p class="mb-6">
              {{ program.description }}
            </p>
          </div>
          
          <div class="program-bullets">
            <ul class="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-8">
              <li v-for="point in program.bulletPoints" :key="point" class="flex items-center">
                <span class="w-1.5 h-1.5 bg-[#FFE54F] rounded-full mr-2"></span>
                {{ point }}
              </li>
            </ul>
          </div>

          <div class="program-link">
            <ButtonLink 
              text="LEARN MORE"
              :url="program.programUrl"
              color="white-trans-yellow-black"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
      
<script>
import programsData from '@/data/programs.json'
import ButtonLink from '../Common/ButtonLink.vue'

export default {
  name: 'ElitePrograms',
  components: {
    ButtonLink
  },
  data() {
    return {
      programsData: programsData.programs
    }
  }
}
</script>

<style scoped>
.programs {
  background-image: url('../../assets/images/home/programs-bg.webp');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: auto;
  min-height: 720px;
}

.programs {
  padding: 64px 0;
}

.program-desc p {
  color: white;
}

.program-bullets {}
.program-link {}

</style>
